import React, { useEffect, useState, useMemo, useCallback } from 'react';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { MultiGrid } from 'react-virtualized';
import { getDetalhado, setLoteMinimo, limparAntecipacoes, atualizaPercEstSegLote } from '../../../../services/DadoMestreService';
import SelectionTable from '../../../../utils/SelectionTable';
import {
    styles,
    getItemsOnPaste,
    constroiObjeto,
    canBeUpdate,
    onCopy,
    caseUpdateLine,
    getPlanilha,
    getAllItems,
    columns,
    getColumnWidth,
} from './Configuration';

import { Col, Row, Label } from 'reactstrap';
import Select from 'react-select';
import { showLoading, hideLoading, showProgressLoading, hideProgressLoading } from '../../../../actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { renderBodyCell } from './Components';

const selection = new SelectionTable('inicio2');

const actions = {
    none: 0,
    onKeyPress: 1,
    onBlur: 2,
    onPaste: 3,
    onChange: 4,
    onClear: 5,
};

const Detalhes = ({
    filter,
    onClose,
    readonly,
    isLoading,
    showLoading,
    hideLoading,
    showProgressLoading,
    hideProgressLoading,
    versaoSelecionada,
}) => {
    const [lastAction, setLastAction] = useState(actions.none);
    const [data, setData] = useState([]);
    const [cor, setCor] = useState();
    const [isFilter, setIsFilter] = useState(false);
    const [oldData, setOldData] = useState([]);
    const [coresFiltradas, setCoresFiltradas] = useState([]);
    const [tamanhosFiltrados, setTamanhosFiltrados] = useState([]);
    const [observacoesFiltradas, setObservacoesFiltradas] = useState([]);

    useEffect(() => {
        showLoading();
        update(filter, false).then((_) => hideLoading());

        return () => hideProgressLoading();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        onCopy(data, selection);
    }, [data]);

    useEffect(() => {
        showLoading();
        update(filter);
        hideLoading();
    }, [isFilter, coresFiltradas, tamanhosFiltrados, observacoesFiltradas]);

    const update = useCallback(
        async (filter) => {
            filter.tabelas = versaoSelecionada.nomeTabelas || undefined;
            try {
                const result = await getDetalhado(filter);
                setOldData([{}, {}, ...result.dados]);

                if (coresFiltradas && coresFiltradas.length) {
                    result.dados = result.dados.filter((sku) => coresFiltradas.includes(sku.grade.substring(0, 5)));
                }
                if (tamanhosFiltrados && tamanhosFiltrados.length) {
                    result.dados = result.dados.filter((sku) => tamanhosFiltrados.includes(sku.grade.substring(5)));
                }
                if (observacoesFiltradas && observacoesFiltradas.length) {
                    result.dados = result.dados.filter((sku) => observacoesFiltradas.includes(sku.observacao));
                }
                if (isFilter) {
                    const filtered = result.dados.filter((sku) => {
                        return sku.saldoNegativo < 0;
                    });
                    return setData([{}, {}, ...filtered]);
                } else {
                    return setData([{}, {}, ...result.dados]);
                }
            } catch (error) {
                return console.error(error);
            }
        },
        [coresFiltradas, tamanhosFiltrados, observacoesFiltradas]
    ); // eslint-disable-line react-hooks/exhaustive-deps

    const atualizaLinha = useCallback(
        (name, linha, i) => {
            const value = constroiObjeto(linha)[name];
            value.tabelas = versaoSelecionada.nomeTabelas || undefined;
            showLoading();
            caseUpdateLine(name, value)
                .then((_) => update(filter))
                .then((_) => hideLoading())
                .catch((_) => hideLoading());
        },
        [coresFiltradas, tamanhosFiltrados, observacoesFiltradas]
    ); // eslint-disable-line react-hooks/exhaustive-deps

    const onChange = useCallback(
        (e, value, i) => {
            if (readonly) return;
            const column = e.target.id;

            if (
                isLoading ||
                !e.target.validity.valid ||
                !['qtdProgramada', 'percAnt', 'percAntVendaFutura', 'percEstoqueSeg'].includes(column)
            )
                return;
            if (column === 'percEstoqueSeg' && e.target.value > 100) return;

            const newData = data.map((row, rowId) => {
                if (rowId !== i) return row;

                return {
                    ...row,
                    [column]: e.target.value,
                };
            });

            setLastAction(actions.onChange);
            setData(newData);
        },
        [data, isLoading] // eslint-disable-line react-hooks/exhaustive-deps
    );

    const handleClose = useCallback((e) => onClose(e, data[2].material, null), [data]); // eslint-disable-line react-hooks/exhaustive-deps
    const handleChangeCor = (cor) => {
        setCor(cor);
    };

    const handleFilterCor = (coresFiltradas) => {
        if (!coresFiltradas) {
            return setCoresFiltradas([]);
        }
        const filteredCores = coresFiltradas.map((cor) => cor.label);
        setCoresFiltradas(filteredCores);
    };

    const handleFilterTamanho = (tamanhosFiltrados) => {
        if (!tamanhosFiltrados) {
            return setTamanhosFiltrados([]);
        }
        const filteredTamanhos = tamanhosFiltrados.map((tamanho) => tamanho.label);
        setTamanhosFiltrados(filteredTamanhos);
    };

    const handleFilterObservacao = (observacaoFiltradas) => {
        if (!observacaoFiltradas) {
            return setObservacoesFiltradas([]);
        }
        const filteredObservacoes = observacaoFiltradas.map((observacao) => observacao.label);
        setObservacoesFiltradas(filteredObservacoes);
    };

    const onBlur = useCallback(
        (e, value, i) => {
            if (readonly) return;
            const column = e.target.id;
            if (isLoading || lastAction === actions.onKeyPress || !canBeUpdate(data, value, column, i)) return;

            setLastAction(actions.onBlur);
            atualizaLinha(column, value, i);
        },
        [isLoading, lastAction, data] // eslint-disable-line react-hooks/exhaustive-deps
    );

    const onKeyPress = useCallback(
        (e, value, i) => {
            if (readonly) return;
            const column = e.target.id;
            if (isLoading || e.key !== 'Enter' || !canBeUpdate(data, value, column, i)) return;
            setLastAction(actions.onKeyPress);
            atualizaLinha(column, value, i);
        },
        [isLoading, data] // eslint-disable-line react-hooks/exhaustive-deps
    );

    const getLoadingConfig = (id, filter) => ({
        url: `/dadomestre/processing/${id}`,
        onClose: () => update(filter),
    });

    const onPaste = (name, e, i) => {
        if (readonly) return;
        const rows = e.clipboardData.getData('text').split('\n');
        const items = getItemsOnPaste(rows, name, i, data);
        setLastAction(actions.onPaste);

        const callback = {
            percEstoqueSeg: atualizaPercEstSegLote,
            percAnt: setLoteMinimo,
            qtdProgramada: setLoteMinimo,
        };

        if (!callback[name]) return console.error('Not implemented `PASTE` on field ' + name);

        callback[name]({ materiais: items, tabelas: versaoSelecionada.nomeTabelas || undefined }).then((id) =>
            showProgressLoading(getLoadingConfig(id, filter))
        );
    };

    const handleClearQuant = () => {
        let items = getAllItems(data);
        setLastAction(actions.onClear);
        limparAntecipacoes(items, cor ? cor.value : '').then((id) => showProgressLoading(getLoadingConfig(id, filter)));
    };

    const getCor = () => {
        let cores = [];
        oldData.forEach((x) => {
            if (x.grade) {
                let corAux = x.grade.substring(0, 5);

                if (!cores.find((e) => e.value === corAux)) {
                    cores.push({ value: corAux, label: corAux });
                }
            }
        });
        return cores;
    };

    const getTamanho = () => {
        let tamanhos = [];
        oldData.forEach((x) => {
            if (x.grade) {
                let corAux = x.grade.substring(5);

                if (!tamanhos.find((e) => e.value === corAux)) {
                    tamanhos.push({ value: corAux, label: corAux });
                }
            }
        });
        return tamanhos;
    };

    const getObservacao = () => {
        let observacoes = [];
        oldData.forEach((x) => {
            if (x.observacao) {
                const observacao = x.observacao;

                if (!observacoes.find((e) => e.value === observacao)) {
                    observacoes.push({ value: observacao, label: observacao });
                }
            }
        });
        return observacoes;
    };

    return useMemo(
        () => (
            <Modal isOpen={true} toggle={handleClose} className='modal-xl mw-100 w-80'>
                <ModalHeader className='modal-title' toggle={handleClose}>
                    <strong>{data && data[2] && data[2].material}</strong> | {data && data[2] && data[2].descricao}
                </ModalHeader>
                <ModalBody className='p-0' style={styles.modal}>
                    <AutoSizer>
                        {({ width, height }) => (
                            <div style={styles.autoSizer(width, height)}>
                                <MultiGrid
                                    style={styles.table}
                                    fixedRowCount={2}
                                    cellRenderer={({ rowIndex, columnIndex, key, style }) =>
                                        renderBodyCell(
                                            rowIndex,
                                            columnIndex,
                                            key,
                                            style,
                                            data,
                                            onChange,
                                            onKeyPress,
                                            onBlur,
                                            onPaste,
                                            selection,
                                            readonly
                                        )
                                    }
                                    className={'BodyGrid'}
                                    data-scroll={'scrollable'}
                                    columnWidth={getColumnWidth}
                                    columnCount={columns.length}
                                    height={height}
                                    noContentRenderer={() => <div className={'noCells'}></div>}
                                    overscanColumnCount={0}
                                    overscanRowCount={10}
                                    rowHeight={35}
                                    rowCount={data.length}
                                    width={width}
                                />
                            </div>
                        )}
                    </AutoSizer>
                </ModalBody>
                <ModalFooter className='d-flex flex-row-reverse justify-content-between'>
                    <div>
                        {!readonly && (
                            <Row className='align-items-start p-0' style={{ height: '38px' }}>
                                <Col md='auto mt-2 pl-0'>
                                    <Label htmlFor='pvSize'>Limpa apenas a Cor:</Label>
                                </Col>

                                <Col style={{ width: '160px' }}>
                                    <Select
                                        id='filtroCor'
                                        onChange={handleChangeCor}
                                        isClearable
                                        value={cor}
                                        name='filtroCor'
                                        options={getCor()}
                                        placeholder='Cor'
                                    />
                                </Col>
                            </Row>
                        )}
                        {!readonly && (
                            <Button type='submit' size='md' color='primary' onClick={handleClearQuant}>
                                Limpar Quantidade
                            </Button>
                        )}
                        <Button
                            type='submit'
                            size='md'
                            color='primary'
                            onClick={(_) =>
                                getPlanilha(filter, versaoSelecionada.nomeTabelas || undefined, {
                                    coresFiltradas,
                                    tamanhosFiltrados,
                                    observacoesFiltradas,
                                })
                            }
                            className='mr-2'
                        >
                            Gerar csv
                        </Button>

                        <Button
                            size='md'
                            color='primary'
                            onClick={(_) => {
                                setIsFilter(!isFilter);
                            }}
                            className='mr-2'
                        >
                            Filtro Saldo Negativo
                        </Button>

                        <Button color='secondary' onClick={handleClose}>
                            Fechar
                        </Button>
                    </div>
                    <div style={{ display: 'flex', gap: '16px' }}>
                        <div style={{ width: '200px' }}>
                            <Select
                                id='filtroCorPorSku'
                                isMulti
                                onChange={handleFilterCor}
                                menuPlacement='top'
                                isClearable
                                name='filtroCor'
                                options={getCor()}
                                placeholder='Cor'
                            />
                        </div>
                        <div style={{ width: '200px' }}>
                            <Select
                                id='filtroTamanhoPorSku'
                                isMulti
                                onChange={handleFilterTamanho}
                                menuPlacement='top'
                                isClearable
                                name='filtroTamanho'
                                options={getTamanho()}
                                placeholder='Tamanho'
                            />
                        </div>
                        <div style={{ width: '200px' }}>
                            <Select
                                id='filtroObservacaoPorSku'
                                isMulti
                                onChange={handleFilterObservacao}
                                menuPlacement='top'
                                isClearable
                                name='filtroObservacao'
                                options={getObservacao()}
                                placeholder='Observação'
                            />
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        ),
        [data, onChange, onKeyPress, update, onBlur, onKeyPress, cor] // eslint-disable-line react-hooks/exhaustive-deps
    );
};

const mapStateToProps = (store) => ({
    isLoading: store.loadingState.loading,
    versaoSelecionada: store.versaoState.versao,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            showLoading,
            hideLoading,
            showProgressLoading,
            hideProgressLoading,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Detalhes);
